import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { P500 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/design-system/no-keyframes-tagged-template-expression -- needs manual remediation (styled-components used)
var wobblingKeyframes = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% { transform: rotate(0deg); }\n  25% { transform: rotate(5deg); }\n  50% { transform: rotate(0deg); }\n  75% { transform: rotate(-5deg); }\n  100% { transform: rotate(0deg); }\n"])));

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var WobblingContainer = styled('div')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  top: 0;\n  left: 0;\n\n  animation-name: ", ";\n  animation-duration: 0.8s;\n  animation-iteration-count: infinite;\n"])), wobblingKeyframes);

// eslint-disable-next-line @atlaskit/design-system/no-keyframes-tagged-template-expression -- needs manual remediation (styled-components used)
var twinklingStarKeyframes = keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(5deg) scale(0.6);\n    opacity: 0.8;\n  }\n  25% {\n    transform: rotate(0deg) scale(1.1);\n    opacity: 1;\n  }\n  50% {\n    transform: rotate(-5deg) scale(0.9);\n    opacity: 0.9;\n  }\n  75% {\n    transform: rotate(0deg) scale(1);\n    opacity: 1;\n  }\n  100% {\n    transform: rotate(5deg) scale(0.6);\n    opacity: 0.8;\n  }\n"])));

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var TwinklingStar = styled('div')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", "px;\n  left: ", "px;\n  width: 10px;\n  height: 10px;\n\n  clip-path: polygon(\n    50% 0%,\n    65% 35%,\n    100% 50%,\n    65% 65%,\n    50% 100%,\n    35% 65%,\n    0 50%,\n    35% 35%\n  );\n\n  background-color: ", ";\n\n  animation-name: ", ";\n  animation-duration: 1.4s;\n  animation-iteration-count: infinite;\n  animation-delay: ", "s;\n"])), function (props) {
  return props.top;
}, function (props) {
  return props.left;
}, "var(--ds-icon-discovery, ".concat(P500, ")"), twinklingStarKeyframes, function (props) {
  return props.delay;
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var InboxButtonContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  margin: 0 ", ";\n"])), "var(--ds-space-075, 6px)");
export var AnimatedInboxButtonContainer = function AnimatedInboxButtonContainer(_ref) {
  var children = _ref.children,
    _ref$shouldPlayAnimat = _ref.shouldPlayAnimation,
    shouldPlayAnimation = _ref$shouldPlayAnimat === void 0 ? false : _ref$shouldPlayAnimat;
  if (!shouldPlayAnimation) {
    return /*#__PURE__*/React.createElement(InboxButtonContainer, null, children);
  }
  return /*#__PURE__*/React.createElement(InboxButtonContainer, {
    "data-testid": "inbox-link-animation-container"
  }, /*#__PURE__*/React.createElement(TwinklingStar, {
    "data-testid": "inbox-twinkling-star",
    delay: 0,
    top: 0,
    left: 18
  }), /*#__PURE__*/React.createElement(TwinklingStar, {
    "data-testid": "inbox-twinkling-star",
    delay: 0.33,
    top: 14,
    left: 0
  }), /*#__PURE__*/React.createElement(TwinklingStar, {
    "data-testid": "inbox-twinkling-star",
    delay: 0.56,
    top: 18,
    left: 20
  }), /*#__PURE__*/React.createElement(WobblingContainer, {
    "data-testid": "inbox-wobbling-button"
  }, children));
};